import ModuleHomeUrl from 'dashboard/leftSideDrawer/ModuleHomeUrl';

import { OhsUser } from '../../user/OhsUser';
import OhsBreadcrumbsNameAndRef from './OhsBreadcrumbsNameAndRef';

const OhsBreadCrumbSysField = (
  ohsBreadcrumbsNameAndRef: OhsBreadcrumbsNameAndRef,
  modulePath: string,
  subPath: string,
  viewPath: string,
  operationPath: string,
  user: OhsUser
) => {
  if (viewPath === 'home') {
    ohsBreadcrumbsNameAndRef.leafName = {
      name: user.configs.sysfield?.TITLE ?? '',
    };
  } else if (viewPath === 'add') {
    ohsBreadcrumbsNameAndRef.moduleRef = {
      href: (ModuleHomeUrl[user.tier.type] as any).sysfield,
      name: user.configs.sysfield?.TITLE ?? '',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Add' };
  } else if (operationPath.indexOf('view') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = {
      href: (ModuleHomeUrl[user.tier.type] as any).sysfield,
      name: user.configs.sysfield?.TITLE ?? '',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'View' };
  } else if (operationPath.indexOf('edit') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = {
      href: (ModuleHomeUrl[user.tier.type] as any).sysfield,
      name: user.configs.sysfield?.TITLE ?? '',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Edit' };
  }
  return ohsBreadcrumbsNameAndRef;
};

export default OhsBreadCrumbSysField;
